import { DataGrid, DecimalEditor, EntityDialog, HtmlContentEditor } from "@serenity-is/corelib";
import { Authorization, Config, ErrorHandling } from "@serenity-is/corelib/q";
import Q from '@serenity-is/corelib/q';
import { siteLanguageList } from "./Helpers/LanguageList";
import { DataGridmini } from "../Serenity/grid";

Config.rootNamespaces.push('CONTAAPP');
EntityDialog.defaultLanguageList = siteLanguageList;
HtmlContentEditor.CKEditorBasePath = "~/Serenity.Assets/Scripts/ckeditor/";
Q.Culture.decimalSeparator = ",";
Q.Culture.groupSeparator = ".";
Q.Culture.decimalDigits = 2;
Q.Culture.dateSeparator = "/";

  

if ($.fn['colorbox']) {
    $.fn['colorbox'].settings.maxWidth = "95%";
    $.fn['colorbox'].settings.maxHeight = "95%";
}

window.onerror = ErrorHandling.runtimeErrorHandler;